export default {
  CREATE: 'CREATE',
  SCHEDULE: 'SCHEDULE',
  SETTINGS: 'SETTINGS',
  SHADER: 'SHADER',
  LOGIN: 'LOGIN',
  PREVIOUS: 'PREVIOUS'
};



// WEBPACK FOOTER //
// ./src/constants/pages.js